module.exports = __webpack_public_path__ + "img/radio-kelantan.8be90a2d.jpg";